import {
  Disclaimer,
  lightTheme,
  Pill,
  SystemProblem,
} from '@vgrubs/components';
import { problemPill } from '../helpers/systemProblemLabels';

/**
 * Where a problem stands, drawn the same way in the list and in the detail:
 * white on a solid fill, like every other status in the admin.
 */
export const SystemProblemPill = ({ problem }: { problem: SystemProblem }) => {
  const { label, color } = problemPill(problem);

  return (
    <Pill $background={color}>
      <Disclaimer $m="0" $color={lightTheme.white} $semiBold $lineHeight="1">
        {label}
      </Disclaimer>
    </Pill>
  );
};
